/**
 * @returns {false|object} false when checked form validation fails
 */
export async function resolveInvoiceFormDataForPayment({
  showInvoiceForm,
  invoiceFormRef
}) {
  if (!showInvoiceForm) {
    return { invoicesEnabled: false };
  }

  const invoiceFormData = await invoiceFormRef?.current?.submit?.();

  if (!invoiceFormData) {
    return false;
  }

  return {
    ...invoiceFormData,
    invoicesEnabled: true
  };
}
